export const NEW_ORDER = '[Orders] New order';
export const EMPTY_BASKET = '[Orders] Reset basket';

export const CREATE_ORDER = '[Orders] Create order';
export const CREATE_ORDER_SUCCESS = '[Orders] Create order Success';
export const CREATE_ORDER_ERROR = '[Orders] Create order Error';

export const GET_ORDERS = '[Orders] Get orders';
export const GET_ORDERS_SUCCESS = '[Orders] Get orders Success';
export const GET_ORDERS_ERROR = '[Orders] Get orders Error';

export const UPDATE_ORDER = '[Orders] Update order';
export const UPDATE_ORDER_SUCCESS = '[Orders] Update order Success';
export const UPDATE_ORDER_ERROR = '[Orders] Update order Error';

export const REMOVE_ORDER = '[Orders] Remove order';
export const REMOVE_ORDER_SUCCESS = '[Orders] Remove order Success';
export const REMOVE_ORDER_ERROR = '[Orders] Remove order Error';